import { Lock, CheckCircle2, PlusCircle, TrendingUp } from "lucide-react";
import { fmtTL } from "../../lib/format";
import { PreviewCard } from "./fields";

function PriceBadge({ multiMode, assignment, hasCardPrices, hideSub }) {
  if (multiMode && !assignment) return <span className="text-[11px] text-slate-400">{hideSub ? "Fiyat kayıt anında belirlenir" : "Taşeron seçilince fiyatlar görünür"}</span>;
  if (hasCardPrices) return <span className="badge-locked"><Lock className="w-3 h-3" /> Fiyat kayıt anında kilitlenir</span>;
  return <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-amber-100 text-amber-800 text-[11px] font-semibold" data-testid="manual-price-badge">Manuel fiyat girişi</span>;
}

function SubmitButtons({ editMode, busy, activeLock, cancelEdit, saveEdit, submit }) {
  if (editMode) {
    return (
      <div className="flex gap-3">
        <button type="button" onClick={cancelEdit} data-testid="entry-edit-cancel-bottom" className="px-4 py-2 rounded-md bg-white text-slate-700 text-sm font-semibold border border-slate-300 hover:bg-slate-50">Vazgeç</button>
        <button type="button" onClick={saveEdit} disabled={busy} data-testid="entry-edit-save" className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-sky-600 text-white text-sm font-semibold hover:bg-sky-700 disabled:opacity-60">
          <CheckCircle2 className="w-4 h-4" /> {busy ? "Güncelleniyor…" : "Güncelle"}
        </button>
      </div>
    );
  }
  const disabled = busy || !!activeLock;
  return (
    <div className="flex gap-3">
      <button type="button" onClick={(e) => submit(e, "close")} disabled={disabled} data-testid="entry-submit-close" className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-white text-slate-700 text-sm font-semibold border border-slate-300 hover:bg-slate-50 disabled:opacity-60">
        Kaydet / Kapat
      </button>
      <button type="button" onClick={(e) => submit(e, "new")} disabled={disabled} data-testid="entry-submit-new" className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-slate-900 text-white text-sm font-semibold hover:bg-slate-800 disabled:opacity-60">
        <PlusCircle className="w-4 h-4" /> {busy ? "Kaydediliyor…" : "Kaydet / Yeni"}
      </button>
    </div>
  );
}

// Uyarı + tutar önizleme kartları + Kaydet butonları; hideSub: şube/müşteri yetkilisi taşeron tutarı ve kârı görmez
export default function EntrySummary({ needsManualPrices, assignmentMissing, pricing, service, fiyatFarki, editMode, busy, activeLock, cancelEdit, saveEdit, submit, hideSub }) {
  const { custTotal, subTotal, profit, multiMode, assignment, hasCardPrices, ffNewPrice, ffDiff, ffNewTotal } = pricing;
  return (
    <>
      {needsManualPrices && !hideSub && (
        <div className="text-xs text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2" data-testid="assignment-missing-warning">
          {assignmentMissing
            ? <>Bu şube için bu hizmete ait atama kartı yok — birim fiyatları yukarıdan <span className="font-semibold">manuel girebilirsiniz</span>. (İsterseniz proje kartı → Hizmetler → Atamalar'dan kart da oluşturabilirsiniz.)</>
            : <>Bu atama kartında birim fiyat tanımlı değil — fiyatları yukarıdan <span className="font-semibold">manuel girin</span>.</>}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 pt-2 border-t border-slate-100">
        <PreviewCard label={hideSub ? "Tutar" : "Müşteri Tutarı"} value={fmtTL(custTotal)} />
        {!hideSub && <PreviewCard label="Taşeron Tutarı" value={fmtTL(subTotal)} />}
        {!hideSub && <PreviewCard label="Brüt Kâr" value={fmtTL(profit)} accent="emerald" />}
        <div className="flex items-center"><PriceBadge multiMode={multiMode} assignment={assignment} hasCardPrices={hasCardPrices} hideSub={hideSub} /></div>
      </div>

      <div className="flex items-center justify-between gap-3 flex-wrap pt-2">
        <div>
          {fiyatFarki && Number.isFinite(ffNewPrice) && ffDiff > 0 && (
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-sky-100 text-sky-800 text-xs font-semibold border border-sky-200" data-testid="ff-submit-summary">
              <TrendingUp className="w-3.5 h-3.5" /> {service ? `${service.name} Fiyat Farkı` : "Fiyat Farkı"}: {fmtTL(ffDiff)} (Yeni Tutar: {fmtTL(ffNewTotal)})
            </span>
          )}
        </div>
        <SubmitButtons editMode={editMode} busy={busy} activeLock={activeLock} cancelEdit={cancelEdit} saveEdit={saveEdit} submit={submit} />
      </div>
    </>
  );
}
